/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TemplaterService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @param useDevFile
     * @param hiddenTabs
     * @param deletedTabs
     * @returns string Ok
     * @throws ApiError
     */
    public fillExcel(
        requestBody: any,
        useDevFile: boolean = false,
        hiddenTabs?: string,
        deletedTabs?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/templater/excel',
            query: {
                'useDevFile': useDevFile,
                'hiddenTabs': hiddenTabs,
                'deletedTabs': deletedTabs,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
